import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';
import { List } from 'immutable';

import Table, { Column, Row } from '../../helpers/Table';
import { IconButton } from '../../helpers/IconButton';

/**
 * Contact executive table with industries.
 */
const ContactExecutiveIndustries = ({ industries, onAdd, changed }) => {
  const title = (
    <>
      <IconButton className="mr5" icon="plus" onClick={onAdd} size="sm" title="Add industry" variant="primary" />
      <span className={classNames({ changed })}>Industry</span>
    </>
  );
  const rows = industries.map((industry, i) => <Row key={i} data={industry} />);

  const wrapper = (value, data) => (
    <span
      className={classNames({
        'text-danger': data.get('deprecated') || data.get('deletedAt'),
      })}
    >
      {value}
    </span>
  );

  return (
    <div className="highlight table-responsive ib">
      <Table className="table table-bordered table-hover">
        <Column className="plus-icon" field="industryLabel" title={title} valueWrapper={wrapper} />
        {rows}
      </Table>
    </div>
  );
};

ContactExecutiveIndustries.propTypes = {
  industries: PropTypes.instanceOf(List).isRequired,
};

export default memo(ContactExecutiveIndustries);
